<template>
	<div class="shop">

		<cart-menu-button>
			<template v-if="quantity > 0">
				<v-list slot="cart-items" three-line dense min-width="250" width="300">
					<cart-item>
						<v-btn
							slot="decrease-button"
							icon
							@click="decreaseQuantity()"
						>
							<v-icon large color="primary">mdi-minus</v-icon>
						</v-btn>

						<v-btn
							slot="increase-button"
							icon
							@click="increaseQuantity()"
						>
							<v-icon large color="primary">mdi-plus</v-icon>
						</v-btn>

						<v-btn icon slot="delete-item" @click="deleteCartItem()">
							<v-icon color="red lighten-1">mdi-delete</v-icon>
						</v-btn>
					</cart-item>
				</v-list>

				<router-link slot="checkout-button" to="/shop/checkout" >
					<base-button
						name="Checkout"
						x-large
						color="#0e6ccd"
						dark
					></base-button>
				</router-link>
			</template>
			<template v-else>
				<v-list slot="cart-items" three-line dense width="300" height="250">
					<v-row justify="center" align="center" class="fill-height">
						<div class="text-center">
							<v-icon x-large>mdi-cart-off</v-icon>
							<p class="text-center grey--text pt-3">You cart is empty</p>
						</div>
					</v-row>
				</v-list>
			</template>
		</cart-menu-button>

		<base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
			<!-- <v-row slot="extra-field">
				<v-col cols="12" sm="12" md="6" lg="6" xl="6">
					<v-text-field
						v-model="merchantCode"
						filled
						rounded
						placeholder="Enter merchant code"
						outlined
						:error-messages="codeErrorMessage"
						light
						class="mr-3 mt-3"
						type="text"
						append-icon="mdi-send"
						@click:append="merchant()"
						@keyup.enter="merchant()"
					></v-text-field>
				</v-col>
			</v-row> -->
		</base-banner>

		<base-goto :breadcrumbs="breadcrumbs"></base-goto>

		<base-divider></base-divider>

		<div id="content">
			<notes-ordered-list :notes="notes"></notes-ordered-list>

			<div id="steps" class="white sec">
				<base-title
					title="How to get your unlimited plan"
				></base-title>

				<v-row justify="center" class="pdx-20">
					<step-column
						v-for="(step, key) in steps"
						:key="key"
						:image="step.image"
						:title="step.title"
						:number="key + 1"
						:line="true"
					></step-column>
				</v-row>
			</div>

			<div id="plan" class="sec">
				<base-title
					title="Get my exclusive Medgate Unliconsultation Plan"
					caption="With the plan you can access the Medgate Telemedicine Center with a simple phone call. You can consult a doctor without the hassle of going to the hospital and waiting in line for hours."
					size="1"
				></base-title>

				<strength-row></strength-row>

				<v-row :class="[ MIXIN_SETUP_UI.show ? 'pdx-15' : 'px-4' ]" justify="center">
					<v-col
						cols="12" sm="6" md="4" lg="4" xl="4"
						v-for="(plan, key) in plans"
						:key="key"
						class="d-flex"
					>
						<plan-card
							:name="plan.name"
							:price="plan.price"
							:discount="plan.discount"
							:description="plan.description"
							:elevation="((key + 2) % 3) ? 0 : 12"
							@add="addToCart(plan)"
							:disable="quantity > 0 ? true : false"
						></plan-card>
					</v-col>
				</v-row>
			</div>

			<div id="testimonial" class="sec white">
				<v-container>
					<base-title
						title="What our happy customers say about the Medgate Unliconsultation Plan"
						size="1"
					></base-title>

					<v-row justify="center">
						<v-col
							cols="12" sm="6" md="6" lg="6" xl="6"
							v-for="(tes, key) in testimonials"
							:key="key"
							class="d-flex px-4"
						>
							<testimonial-card
								:title="tes.title"
								:description="tes.caption"
								:ratings="tes.ratings"
								:name="tes.name"
							></testimonial-card>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

	</div>
</template>

<script>
import StrengthRow from "@/components/shop/StrengthRow.vue";
import PlanCard from "@/components/shop/PlanCard.vue";
import TestimonialCard from "@/components/home/TestimonialCard.vue";
import CartMenuButton from "@/components/shop/CartMenuButton.vue";
import CartItem from "@/components/shop/CartItem.vue";
import NotesOrderedList from "@/components/shop/NotesOrderedList.vue";
import StepColumn from "@/components/shop/StepColumn.vue";

import Repository from "@/api/repositories";
const ShopBannersApi = Repository.get("shopBanners");
const ShopPlansApi = Repository.get("shopPlans");
const ShopTestimonialsApi = Repository.get("shopTestimonials");
const ShopMerchantsApi = Repository.get("shopMerchants");

	export default {
		name: "Shop",
		components: {
			StrengthRow,
			PlanCard,
			TestimonialCard,
			CartMenuButton,
			CartItem,
			NotesOrderedList,
			StepColumn
		},
		data: () => ({
			merchantCode: null,
			codeErrorMessage: '',
			merchants: [],
			toggleCode: false,
			testimonials: [],
			banner: [],
			plans: [],
			notes: [
				"Medgate Unliconsultation Plan is for Philippines residents only since all our Filipino doctors are licensed to practice and prescribe medication in the Philippines only.",
				"The Medgate Unliconsultation Plan is not designed for immediate medical care at the time of purchase.",
				"You will receive the purchase confirmation email within the period of two banking days along with a unique access key and activation code.",
				"Once the account has been activated, the member will be able to access Medgate Philippines' telemedicine service on demand at any time.",
				"The Medgate Unliconsultation Plan is non-transferrable and can only be used by the assigned account member."
			],
			steps: [
				{
					image: require("@/assets/images/shop_1.png"),
					title: "Fill out the form"
				},
				{
					image: require("@/assets/images/shop_2.png"),
					title: "Pay"
				},
				{
					image: require("@/assets/images/shop_3.png"),
					title: "Wait for the confirmation"
				},
				{
					image: require("@/assets/images/shop_4.png"),
					title: "Activate your access key and activation code"
				}
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Shop",
					link: "/shop",
					active: true
				},
			]
		}),
		computed: {
			quantity: function () {
				return this.$store.getters['cart/quantity']
			},
			total: function() {
        return this.$store.getters['cart/total']
      }
		},
		async mounted() {
			this.getShopPlans();
			this.getShopTestimonials();
			this.getMerchants();
			await this.getShopBanner();
			this.setHeaderColor();
		},
		methods: {
			setHeaderColor() {
				if (this.banner.backgroundColor)
					this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
				else
					this.$store.commit('page/defaultHeaderColor')
			},
			async getShopBanner() {
				try {
					const { data } = await ShopBannersApi.get();

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let apiData = data.data[0];

						let buttons = apiData.buttons.map(button => {
							return {
								name: button.label,
								icon: button.image,
								link: button.redirect,
								color: JSON.parse(button.styling).color
							}
						});

						let banner = {
							buttons: buttons,
							image: apiData.background_image.main,
							caption: apiData.caption,
							title: apiData.title,
							titleColor: apiData.styles.titleColor,
							captionColor: apiData.styles.captionColor,
							backgroundColor: apiData.styles.backgroundColor
						}

						this.banner = banner;
					}

					console.log('[shop-banner]', data, this.banner);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopPlans() {
				try {
					const { data } = await ShopPlansApi.get();

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let plans = data.data.map(plan => {
							var details = {
								id: plan.id,
								name: plan.name,
								price: plan.price,
								discount: plan.discount,
								description: plan.description,
								maxDependents: plan.no_key_generate
							}

							if (plan.other_details)
									details.member = plan.other_details.applyDetails
										? parseInt(plan.other_details.amountPerHousehold)
										: null
							else
								details.member = null

							return details
						});

						this.plans = plans;
					}

					console.log('[shop-plans]', data, this.plans);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopTestimonials() {
				try {
					const { data } = await ShopTestimonialsApi.get();

					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let testimonials = data.data.map(tes => {
							return {
								name: tes.name,
								title: tes.title,
								ratings: parseInt(tes.ratings),
								caption: tes.caption
							}
						});

						this.testimonials = testimonials;
					}

					console.log('[shop-testimonials]', data, this.testimonials);
				}
				catch(error) {
					console.log(error);
				}
			},
			addToCart(plan) {
				var item = {
          description: plan.description,
					discount: plan.discount,
					id: plan.id,
					name: plan.name,
					price: plan.price,
					quantity: 1,
					member: plan.member,
					memberQuantity: 0,
					maxDependents: plan.maxDependents
				}
				this.$store.commit('cart/setItem', item);
				console.log('cart-item', item);
				// plan.quantity = 1;
				// var cartItems = JSON.parse(localStorage.getItem('cartItems'));

				// if (localStorage.cartItems) {
				// 	var sameItemIndex = cartItems.findIndex(item =>
				// 		item.name == plan.name
				// 	);

				// 	if (sameItemIndex >= 0) {
				// 		cartItems[sameItemIndex].quantity++;
				// 	}
				// 	else {
				// 		if (!cartItems.length) {
				// 			cartItems.push(plan);
				// 		}
				// 	}

				// 	this.cartItems = cartItems;
				// 	localStorage.cartItems = JSON.stringify(cartItems);
				// }
				// else {
				// 	let plans = [];
				// 	plans.push(plan);
				// 	localStorage.cartItems = JSON.stringify(plans);
				// 	this.cartItems = JSON.parse(localStorage.getItem('cartItems'));
				// }

				// this.getCartTotal()
			},
			// saveCartItems() {
			// 	var cartItems = JSON.parse(localStorage.getItem('cartItems'));
			// 	if (cartItems) {
			// 		this.cartItems = cartItems;
			// 	}
			// },
			// getCartTotal() {
			// 	let data = JSON.parse(localStorage.getItem('cartItems'));

			// 	if (data) {
			// 		var total = data.reduce(function (total, currentVal) {
			// 			return total + parseFloat(currentVal.price * currentVal.quantity);
			// 		}, 0);

			// 		this.cartTotal = total;
			// 		localStorage.cartTotal = this.cartTotal;
			// 		// save new item quantity for badge number
			// 		if (data.length) {
			// 			this.cartItemsQuantity = data[0].quantity;
			// 		}
			// 		else {
			// 			this.cartItemsQuantity = 0;
			// 		}
			// 	}
			// },
			deleteCartItem() {
				this.$store.commit('cart/deleteItem')
				// var cartItems = JSON.parse(localStorage.getItem('cartItems'));

				// cartItems.splice(key, 1);
				// localStorage.cartItems = JSON.stringify(cartItems);
				// this.cartItems = cartItems;

				// this.getCartTotal();
			},
			increaseQuantity() {
				this.$store.commit('cart/increaseQuantity')
        // var cartItems = JSON.parse(localStorage.getItem('cartItems'));
				// cartItems[key].quantity++;
				// this.cartItems = cartItems;
				// localStorage.cartItems = JSON.stringify(cartItems);
				// this.getCartTotal();
      },
      decreaseQuantity() {
				this.$store.commit('cart/decreaseQuantity')
        // var cartItems = JSON.parse(localStorage.getItem('cartItems'));

				// if (cartItems[key].quantity <= 1) {
				// 	cartItems.splice(key, 1);
				// }
				// else {
				// 	cartItems[key].quantity--;
				// }

				// this.cartItems = cartItems;
				// localStorage.cartItems = JSON.stringify(cartItems);
				// this.getCartTotal();
			},
			// merchant() {
			// 	var index = this.merchants.findIndex(merchant =>
			// 		merchant.code == this.merchantCode
			// 	);

			// 	if (index >= 0) {
			// 		localStorage.setItem('merchantId', this.merchants[index].id);
			// 		this.$router.push({ name: 'ShopMerchant', params: { slug: this.merchants[index].slug } })
			// 	}
			// 	else {
			// 		this.codeErrorMessage = "Invalid code!";
			// 	}
			// 	setTimeout(() => this.codeErrorMessage = null, 2000);
			// },
			async getMerchants() {
				try {
					const { data } = await ShopMerchantsApi.get();

					if (data) {
						let merchants = data.data.map(merchant => {
							return {
								id: merchant.id,
								name: merchant.name,
								code: merchant.code,
								slug: merchant.slug,
							}
						});

						this.merchants = merchants;
					}

					console.log('[shop-merchants]', data, this.merchants);
				}
				catch(error) {
					console.log(error);
				}
			},
		}
	}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.v-input__slot {
	background: white !important;
}
</style>
